import React, { useState, useEffect } from "react"
import { asDialogData } from "../../../core/utils/utils"
import {
    Autocomplete, Button, Dialog, DialogActions, DialogContent,
    DialogTitle, MenuItem, Stack, TextField
} from "@mui/material"
import { useGetAllUsersDetailsQuery } from "../../../core/api/users-api"
import {
    useGetAchievementCategoriesAdminQuery,
    useGrantAchievementMutation,
} from "../../../core/api/experience-api"
import ResponseDialog from "../../ResponseDialog"

export default function GrantAchievementDialog({ open, onClose, defaultEmail }) {
    const { data: users = [] } = useGetAllUsersDetailsQuery()
    // Полный каталог по всем сезонам: ручной grant может закрывать долги
    // прошлого сезона (ачивка наследует сезон своей категории).
    const { data: achievementCategories = [] } = useGetAchievementCategoriesAdminQuery()
    const [grant, grantResp] = useGrantAchievementMutation()

    const [selectedUser, setSelectedUser] = useState(null)
    const [achievementCategoryId, setAchievementCategoryId] = useState("")
    const [reason, setReason] = useState("")
    const [respOpen, setRespOpen] = useState(false)
    const [actionResp, setActionResp] = useState({})

    useEffect(() => {
        if (open && defaultEmail) {
            const u = users.find(u => u.email === defaultEmail)
            if (u) setSelectedUser(u)
        }
    }, [open, defaultEmail, users])

    async function submit() {
        if (!selectedUser || !achievementCategoryId) return
        const resp = await grant({
            email: selectedUser.email,
            achievementCategoryId,
            reason,
        })
        setActionResp(asDialogData(resp)); setRespOpen(true)
        onClose()
    }

    return (
        <>
            <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
                <DialogTitle>Grant achievement</DialogTitle>
                <DialogContent>
                    <Stack spacing={2} sx={{ mt: 1 }}>
                        <Autocomplete
                            options={users}
                            getOptionLabel={(o) => o.fullName || o.email || ""}
                            value={selectedUser}
                            onChange={(_, v) => setSelectedUser(v)}
                            renderInput={(params) => <TextField {...params} label="Employee" required />}
                            disabled={!!defaultEmail}
                        />
                        <TextField
                            select
                            label="Achievement"
                            value={achievementCategoryId}
                            onChange={e => setAchievementCategoryId(e.target.value)}
                            required
                        >
                            {achievementCategories.map(a => (
                                <MenuItem key={a.id} value={a.id}>{a.name}{a.season ? ` (сезон ${a.season})` : ""}</MenuItem>
                            ))}
                        </TextField>
                        <TextField
                            label="Reason"
                            value={reason}
                            onChange={e => setReason(e.target.value)}
                            multiline
                            minRows={2}
                        />
                    </Stack>
                </DialogContent>
                <DialogActions>
                    <Button onClick={onClose}>Cancel</Button>
                    <Button
                        variant="contained"
                        color="warning"
                        onClick={submit}
                        disabled={!selectedUser || !achievementCategoryId || grantResp.isLoading}
                    >
                        Grant
                    </Button>
                </DialogActions>
            </Dialog>
            <ResponseDialog
                open={respOpen}
                onClose={() => setRespOpen(false)}
                responseData={actionResp}
                label="Achievement"
                information="Granted"
            />
        </>
    )
}
